import React from 'react';
import './index.scss';
import Loader from "react-loader-spinner";
import peabody from "../../assets/img/peabody-logo-teal.png";

interface LoaderPopupProps {
    message?: string;
    className?: string;
    msg1?: string;
}

const LoaderPopup: React.FC<LoaderPopupProps> = ({ message = "Loading...", className, msg1 = "" }) => {
    return (
        <>
            <div className="loader-popup-overlay">
                <div className={className}>
                    <div className="logo-container" style={{ position: "absolute", top: "1rem", left: "2rem" }}>
                        <img src={peabody} className="logo" alt="Peabody Logo" />
                    </div>
                    <hr style={{ width: "100vw", borderTop: "1px solid grey", margin: "2.5rem 0" }} />
                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100vh", textAlign: "center", marginBottom: "6rem" }}>
                        <p>{message}</p>
                        <p>{msg1}</p>
                    </div>
                    <div 
                        className="loader-spinner-container"  
                        data-testid="loader-spinner" 
                        style={{ top: window.innerWidth <= 768 ? "55%" : "50%" }}
                    >
                        <Loader
                            type="ThreeDots"
                            color="#00BFFF"
                            height={50}
                            width={50}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
export default LoaderPopup;